
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../actions/api';

export const fetchStockDashboardData = createAsyncThunk(
  'stockDashboard/fetchStockDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/stocks');
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch stock dashboard data');
    }
  }
);

const stockDashboardSlice = createSlice({
  name: 'stockDashboard',
  initialState: {
    totalStocks: 0,
    lowStocks: 0,
    returnsStoks: 0,
    stockLevel: [],
    fastMovingProductName: {},
    lowStocksLevel: [],
    lowStocks: 0,
    expiryTracking: [],
    stockTurnOverRate: {},
    saleVsReturns: {},
    purchaseVsReturns: {},
    summaryStrip: {},
    stockByCategory: [],
    lowStockAlerts: [],
    expiryRisk: {},
    priceMarginWatch: [],
    fastSlowMovers:{},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        state.totalStocks = action.payload.totalStocks || 0;
        state.lowStocks = action.payload.lowStocks || 0;
        state.returnsStoks = action.payload.returnsStoks || 0;
        // Stock Level
        state.stockLevel = action.payload.stockLevel || [];

        // Fast Moving Products by Year
        state.fastMovingProductName = action.payload.fastMovingProductName || {};

        // Low Stocks
        state.lowStocksLevel = action.payload.lowStocksLevel || [];
        state.lowStocks = action.payload.lowStocks || action.payload.lowStocksLevel?.length || 0;

        // Expiry Tracking
        state.expiryTracking = action.payload.expiryTracking || [];
        // Sales vs Returns
        state.saleVsReturns = action.payload.saleVsReturns || {};

        // Purchases vs Returns
        state.purchaseVsReturns = action.payload.purchaseVsReturns || {};

        // Stock Turnover Rate
        state.stockTurnOverRate = action.payload.stockTurnOverRate || {};
        state.summaryStrip = action.payload.summaryStrip || {};
        state.stockByCategory = action.payload.stockByCategory || [];
        state.lowStockAlerts = action.payload.lowStockAlerts || [];
        state.expiryRisk = action.payload.expiryRisk || {};
        state.priceMarginWatch = action.payload.priceMarginWatch || [];
        state.fastSlowMovers = action.payload.fastSlowMovers || {};
      })
      .addCase(fetchStockDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export default stockDashboardSlice.reducer;